import { EquipmentLibraryCardData } from "./EquipmentLibraryCard";
import { fullModelName } from "portal/utils/atkEquipment";
import { TFunction } from "i18next";
import { Tractor } from "protos/atk/autotractor";
import React from "react";

export function getTractorLibraryCardData(
  t: TFunction,
  tractor: Tractor
): EquipmentLibraryCardData<Tractor> {
  const modelName = fullModelName(t, tractor);

  return {
    entity: tractor,
    name: tractor.name,
    updatedAt: tractor.updatedAt,
    secondaryLabel: modelName,
    details: [
      {
        label: t("views.autotractor.equipment.modelName"),
        value: <>{modelName}</>,
      },
    ],
  };
}
